import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { DEFAULT_PAGE, DEFAULT_NAV } from './defaultPage';
import { api } from '../api';

const PageContext = createContext(null);

// Content now lives in the Cloudflare gateway (D1). No Firebase, no build step.
export function PageProvider({ children }) {
  const [page, setPage] = useState({ sections: null, nav: [] });
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      const d = await api.content();
      setPage({
        sections: Array.isArray(d.sections) ? d.sections : [],
        nav: Array.isArray(d.nav) && d.nav.length ? d.nav : DEFAULT_NAV,
      });
    } catch (e) {
      // Gateway unreachable — try the static snapshot shipped with the build.
      let painted = false;
      try {
        const res = await fetch(`${process.env.PUBLIC_URL}/content.json`, { cache: 'no-cache' });
        if (res.ok) {
          const d = await res.json();
          if (Array.isArray(d.sections) && d.sections.length) {
            setPage({ sections: d.sections, nav: Array.isArray(d.nav) && d.nav.length ? d.nav : DEFAULT_NAV });
            painted = true;
          }
        }
      } catch {}
      if (!painted) {
        setPage((p) => (Array.isArray(p.sections) && p.sections.length
          ? p
          : { sections: DEFAULT_PAGE, nav: DEFAULT_NAV }));
      }
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const save = useCallback(async (sections) => {
    const nav = Array.isArray(page.nav) ? page.nav : DEFAULT_NAV;
    await api.saveContent(sections, nav);
    setPage((p) => ({ ...p, sections }));
  }, [page.nav]);

  const saveNav = useCallback(async (nav) => {
    const sections = Array.isArray(page.sections) ? page.sections : DEFAULT_PAGE;
    await api.saveContent(sections, nav);
    setPage((p) => ({ ...p, nav }));
  }, [page.sections]);

  return (
    <PageContext.Provider value={{ page, loaded, reload, save, saveNav }}>
      {children}
    </PageContext.Provider>
  );
}

export function usePage() {
  return useContext(PageContext);
}
